import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './MovuRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class MovuRobotics_inbound_services_pick_confirmationService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { Task_id?: string, wh_id?: string, Srcloc?: string, Pallet_id?: string, Success?: any }): Promise<{ result?: $frontendTypes.MovuRobotics.Output, outputDetails?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/pick-confirmation`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

